"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uuid = require("uuid");

var connector_1 = require("./connector");

var DEFAULT_TTL = 60 * 60 * 48;
/**
 * Registrar connector implementation for twilsock
 */

var TwilsockConnector =
/*#__PURE__*/
function (_connector_1$Connecto) {
  _inherits(TwilsockConnector, _connector_1$Connecto);

  function TwilsockConnector(context, twilsock, config) {
    var _this;

    _classCallCheck(this, TwilsockConnector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TwilsockConnector).call(this, config));
    _this.twilsock = twilsock;
    _this.context = context;
    context.id = uuid.v4();

    _this.twilsock.on('stateChanged', function (state) {
      if (state !== 'connected') {
        _this.emit('transportReady', false);
      }
    });

    _this.twilsock.on('registered', function (id) {
      if (context && id === context.id && twilsock.state === 'connected') {
        _this.emit('transportReady', true);
      }
    });

    return _this;
  }

  _createClass(TwilsockConnector, [{
    key: "setNotificationId",
    value: function setNotificationId() {}
  }, {
    key: "updateToken",
    value: function updateToken(token) {// no need to do anything here, twilsock backend handles it on it's own
      // so just ignoring here
    }
  }, {
    key: "updateContextRequest",
    value: function () {
      var _updateContextRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(messageTypes) {
        var context;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context = {
                  product_id: this.context.productId,
                  notification_protocol_version: 4,
                  endpoint_platform: this.context.platform,
                  message_types: messageTypes
                };
                this.emit('transportReady', false);
                _context.next = 4;
                return this.twilsock.setNotificationsContext(this.context.id, context);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateContextRequest(_x) {
        return _updateContextRequest.apply(this, arguments);
      }

      return updateContextRequest;
    }()
  }, {
    key: "updateRegistration",
    value: function () {
      var _updateRegistration = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(registration, reasons) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (reasons.has('messageType')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return this.updateContextRequest(Array.from(registration.messageTypes));

              case 4:
                return _context2.abrupt("return", registration);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateRegistration(_x2, _x3) {
        return _updateRegistration.apply(this, arguments);
      }

      return updateRegistration;
    }()
  }, {
    key: "removeRegistration",
    value: function removeRegistration() {
      return this.twilsock.removeNotificationsContext(this.context.id);
    }
  }]);

  return TwilsockConnector;
}(connector_1.Connector);

exports.TwilsockConnector = TwilsockConnector;